export const UPDATE_SEARCHLIST = 'onboardingTrainingTrackerSearch/updateResults'
export const RESET_FILTERS = 'onboardingTrainingTrackerSearch/reset'
export const RESET_RESULTS = 'onboardingTrainingTrackerSearch/resetTableData'
export const UPDATE_CONTROL_NO = 'onboardingTrainingTrackerAdd/getControlNo'
export const GET_DETAIL = 'onboardingTrainingTracker/getDetails'
export const SET_CONFIRM_MODAL = 'onboardingTrainingTrackerSearch/setConfirmModal'
export const HIDE_CONFIRM_MODAL = 'onboardingTrainingTrackerSearch/hideConfirmModal'
export const SHOW_CONFIRM_MODAL = 'onboardingTrainingTrackerSearch/showConfirmModal'

// SEARCH FILTER TYPES
export const APPLY_FILTERS = 'onboardingTrainingTrackerSearch/applySearchFilter'
export const CHG_FILTER_DATA = 'onboardingTrainingTrackerSearch/changeFilterField'
export const CHG_FILTER_PAGE = 'onboardingTrainingTrackerSearch/changePage'
export const CHG_FILTER_PAGE_SIZE = 'onboardingTrainingTrackerSearch/changePageSize'
export const CHG_FILTER_SORT = 'onboardingTrainingTrackerSearch/changeSortModel'
export const IS_LOADING = 'onboardingTrainingTrackerSearch/isLoading'
export const CHG_SELECTED_ROWS = 'onboardingTrainingTrackerSearch/changeSelected'
export const HIDE_LIST_ALERT = 'onboardingTrainingTrackerSearch/hideAlert'
export const SET_LIST_ALERT = 'onboardingTrainingTrackerSearch/setAlertModal'

// ADD FORM TYPES
export const CHG_FIELD = 'onboardingTrainingTrackerAdd/changeField'
export const CHG_STATUS = 'onboardingTrainingTrackerAdd/changeStatus'
export const CHG_EMPLOYEE_ID = 'onboardingTrainingTrackerAdd/changeEmployeeId'
export const CHG_INCOME_ID = 'onboardingTrainingTrackerAdd/changeIncomeId'
export const CHG_AMOUNT = 'onboardingTrainingTrackerAdd/changeAmount'
export const CHG_EFFECTIVE_DATE = 'onboardingTrainingTrackerAdd/changeEffectiveData'
export const CHG_MEMO = 'onboardingTrainingTrackerAdd/changememo'
export const RESET_ADD_DATA = 'onboardingTrainingTrackerAdd/reset'
export const UPD_ADD_ALERT = 'onboardingTrainingTrackerAdd/updateAlert'
export const HIDE_ADD_ALERT = 'onboardingTrainingTrackerAdd/hideAlert'
export const UPD_ADD_MEMO_CHAR_COUNT = 'onboardingTrainingTrackerAdd/updateMemoCharCount'
export const INSERT_LOADING = 'onboardingTrainingTrackerAdd/isLoading'
export const SET_ADD_DATA = 'onboardingTrainingTrackerAdd/setAddData'

// DETAIL FORM TYPES
export const UPD_DETAIL_TITLE = 'onboardingTrainingTrackerDetail/changeTitle'
export const RESET_DETAIL_DATA = 'onboardingTrainingTrackerDetail/reset'
export const CHG_DETAIL_DATA = 'onboardingTrainingTrackerDetail/changeFieldData'
export const UPD_DETAIL_MODE = 'onboardingTrainingTrackerDetail/changeMode'
export const HAS_DETAIL_LOADED = 'onboardingTrainingTrackerDetail/hasDetailLoaded'
export const SET_DETAIL_DATA = 'onboardingTrainingTrackerDetail/setDetailData'
export const UPD_AMOUNT = 'onboardingTrainingTrackerDetail/changeAmount'
export const UPD_DETAIL_MEMO_CHAR_COUNT = 'onboardingTrainingTrackerDetail/updateMemoCharCount'
export const UPD_DETAIL_DATA = 'onboardingTrainingTrackerDetail/updateDetailData'
export const SET_DETAIL_CONFIRM_MODAL = 'onboardingTrainingTrackerDetail/setConfirmModal'
export const HIDE_DETAIL_CONFIRM_MODAL = 'onboardingTrainingTrackerDetail/hideConfirmModal'
export const SHOW_DETAIL_CONFIRM_MODAL = 'onboardingTrainingTrackerDetail/showConfirmModal'
export const SET_DETAIL_ALERT = 'onboardingTrainingTrackerDetail/setAlertModal'
export const HIDE_DETAIL_ALERT = 'onboardingTrainingTrackerDetail/hideAlert'
export const CHANGE_UPDATE_VALUES = 'onboardingTrainingTrackerDetail/changeUpdateValues'
export const FETCH_TRAINING_VALUES = 'onboardingTrainingTrackerDetail/fetchTrainingValues'

